import axios from 'axios';
import { supabase } from '../config/supabase.config';
import { API_URL } from '../config/supabase.config';
import type { AssignmentRequest, AssignmentResponse, AssignmentHistory } from '../types/assignments.types';

// Get auth headers using Supabase session
const getAuthHeader = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    headers: {
      Authorization: `Bearer ${session?.access_token}`,
      'Content-Type': 'application/json',
    },
  };
};

export const assignmentsService = {
  // Assign lead to user
  async assignLead(data: AssignmentRequest): Promise<AssignmentResponse> {
    const config = await getAuthHeader();
    const response = await axios.post<AssignmentResponse>(
      `${API_URL}/assignments`,
      data,
      config
    );
    return response.data;
  },

  // Get assignment history for a lead
  async getLeadAssignmentHistory(leadId: string): Promise<AssignmentHistory[]> {
    const config = await getAuthHeader();
    const response = await axios.get<AssignmentHistory[]>(
      `${API_URL}/assignments/lead/${leadId}/history`,
      config
    );
    return response.data;
  },

  // Get user's assigned leads
  async getUserAssignedLeads(userId: string): Promise<AssignmentResponse[]> {
    const config = await getAuthHeader();
    const response = await axios.get<AssignmentResponse[]>(
      `${API_URL}/assignments/user/${userId}`,
      config
    );
    return response.data;
  },

  // Unassign lead
  async unassignLead(leadId: string): Promise<void> {
    const config = await getAuthHeader();
    await axios.delete(
      `${API_URL}/assignments/lead/${leadId}`,
      config
    );
  },

  // Get organization users for assignment
  async getOrganizationUsers(): Promise<Array<{ id: string; full_name: string; email: string; role: string }>> {
    const config = await getAuthHeader();
    const response = await axios.get(
      `${API_URL}/users/organization`,
      config
    );
    return response.data;
  }
};
